import * as types from './yarnActionTypes';

const initialState = {
  yarnData: null,
  yarnList: null,
  createYarnData: null,
  createYarnError: null,
  updateYarnData: null,
  updateYarnError: null,
  deleteYarnData: null,
  deleteYarnError: null,
};

export const yarnReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_YARN_DATA:
      return {
        ...state,
        yarnData: action.payload || null,
        yarnList: action.payload?.YarnList || action.payload?.Yarns || [],

      };
    case types.GET_YARN_ERROR:
      return {
        ...state,
        yarnData: null,
        yarnList: [],
      };

    case types.CREATE_YARN_REQUEST:
      return {
        ...state,
        createYarnError: null,
      };
    case types.CREATE_YARN_DATA:
      return {
        ...state,
        createYarnData: action.payload,
        createYarnError: null,
      };
    case types.CREATE_YARN_ERROR:
      return {
        ...state,
        createYarnData: null,
        createYarnError: action.payload,
      };

    case types.UPDATE_YARN_REQUEST:
      return {
        ...state,
        updateYarnError: null,
      };
    case types.UPDATE_YARN_DATA:
      return {
        ...state,
        updateYarnData: action.payload,
        updateYarnError: null,
      };
    case types.UPDATE_YARN_ERROR:
      return {
        ...state,
        updateYarnData: null,
        updateYarnError: action.payload,
      };

    case types.DELETE_YARN_REQUEST:
      return {
        ...state,
        deleteYarnError: null,
      };
    case types.DELETE_YARN_DATA:
      return {
        ...state,
        deleteYarnData: action.payload,
        deleteYarnError: null,
      };
    case types.DELETE_YARN_ERROR:
      return {
        ...state,
        deleteYarnData: null,
        deleteYarnError: action.payload,
      };

    default:
      return state;
  }
};
